import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FeedbackLoop = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25.5 18.675C25.5 18.612 25.5 18.562 25.5 18.5C25.5 15.025 23.625 11.975 20.825 10.325C20.938 9.9 21 9.462 21 9C21 6.237 18.762 4 16 4C13.238 4 11 6.237 11 9C11 9.463 11.063 9.9 11.175 10.325C8.375 11.975 6.5 15.025 6.5 18.5C6.5 18.563 6.5 18.613 6.5 18.675C5 19.538 4 21.163 4 23C4 25.762 6.237 28 9 28C10.088 28 11.088 27.65 11.9 27.062C13.138 27.662 14.525 28 16 28C17.475 28 18.85 27.663 20.1 27.062C20.925 27.649 21.925 28 23 28C25.762 28 28 25.762 28 23C28 21.15 26.988 19.538 25.5 18.675ZM16 6C17.65 6 19 7.35 19 9C19 10.65 17.65 12 16 12C14.35 12 13 10.65 13 9C13 7.35 14.35 6 16 6ZM6 23C6 21.35 7.35 20 9 20C10.65 20 12 21.35 12 23C12 24.65 10.65 26 9 26C7.35 26 6 24.65 6 23ZM13.325 25.5C13.75 24.762 14 23.913 14 23C14 20.238 11.762 18 9 18C8.838 18 8.675 18.012 8.512 18.025C8.674 15.525 10.062 13.35 12.087 12.113C12.999 13.263 14.412 14 15.999 14C17.586 14 18.999 13.262 19.911 12.113C21.936 13.351 23.324 15.525 23.486 18.025C23.323 18.013 23.161 18 22.998 18C20.236 18 17.998 20.238 17.998 23C17.998 23.913 18.248 24.762 18.673 25.5C17.836 25.825 16.935 26 15.998 26C15.061 26 14.148 25.825 13.323 25.5H13.325ZM23 26C21.35 26 20 24.65 20 23C20 21.35 21.35 20 23 20C24.65 20 26 21.35 26 23C26 24.65 24.65 26 23 26Z" />
	</svg>
);

export default FeedbackLoop;
